import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { apiBase } from '../services/apiBase';
import { reducers } from '../slices';

export const store = configureStore({
  reducer: {
    ...reducers,
    [apiBase.reducerPath]: apiBase.reducer,
  },
  // @ts-expect-error RTK middleware type mismatch from duplicate package versions in monorepo
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiBase.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
